import styled from "styled-components";
import Header from "../../components/common/Header";
import INTRO_SVG from "../../images/Intro.svg";
import Footer from "../../components/common/Footer";
import AboutUs from "../../components/home/AboutUs";
import Review from "../../components/home/Review";
import Profile from "../../components/home/Profile";

function Home(){
    return(
        <Container>
            <Header />
            <Intro src={INTRO_SVG} alt="intro"/>
            <div className="inner">
                <Content>
                    <AboutUs />
                    <Review />
                    <Profile />
                </Content>
            </div>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
`

const Intro = styled.img`
    width: 100%;
    margin-top: 78px;
`

const Content = styled.div`
    padding: 120px 0px;
    display:flex;
    flex-direction: column;
    gap: 120px;
`

export default Home;